import { Component } from '@angular/core';
import { version } from '../../../environments/version';

@Component({
  selector: 'wpro-version',
  template: `
    <pre>{{ version | json }}</pre> `,
  standalone:false
})
export class InfoComponent {
  public readonly version = version;
}

